<template>
  <section class="cabinet-layout">
    <AppHeader />
    <main>
      <section class="cabinet-main">
        <div class="_bg-light">
          <div class="container _py-16 _py-md-12 _px-md-4 _py-sm-8">
            <h1 class="_tc-dark _fs-48 _fs-sm-32 _lh-38 _lh-64 _fw-700">
              {{ $t("cabinet.title") }}
            </h1>
          </div>
        </div>
        <div class="container _px-md-4 _py-16 _py-sm-12">
          <div class="cabinet__menu _mb-6">
            <div
              class="cabinet__menu-item _mr-auto"
              :class="{
                'cabinet__menu-item_active': $route.name === 'Cabinet',
              }"
              @click="choiceMenuItem({ name: 'Cabinet' })"
            >
              {{ $t("cabinet.dashboard.menu[0]") }}
            </div>
            <div
              class="cabinet__menu-item _mr-auto _ml-8"
              :class="{
                'cabinet__menu-item_active': $route.name === 'CabinetUserData',
              }"
              @click="choiceMenuItem({ name: 'CabinetUserData' })"
            >
              {{ $t("cabinet.dashboard.menu[1]") }}
            </div>
            <div
              class="cabinet__menu-item _mr-auto _ml-8"
              :class="{
                'cabinet__menu-item_active': $route.name === 'CabinetPrizes',
              }"
              @click="choiceMenuItem({ name: 'CabinetPrizes' })"
            >
              {{ $t("cabinet.dashboard.menu[2]") }}
            </div>
            <div
              class="cabinet__menu-item _mr-auto _ml-8"
              :class="{
                'cabinet__menu-item_active':
                  $route.name === 'CabinetAchievements',
              }"
              @click="choiceMenuItem({ name: 'CabinetAchievements' })"
            >
              {{ $t("cabinet.dashboard.menu[3]") }}
            </div>
            <div
              class="cabinet__menu-item _mr-auto _ml-8"
              :class="{
                'cabinet__menu-item_active': $route.name === 'Favorites',
              }"
              @click="choiceMenuItem({ name: 'Favorites' })"
            >
              {{ $t("cabinet.dashboard.menu[4]") }}
            </div>
            <div
              class="cabinet__menu-item _ml-8"
              :class="{
                'cabinet__menu-item_active': $route.name === 'Statistics',
              }"
              @click="choiceMenuItem({ name: 'Statistics' })"
            >
              {{ $t("cabinet.dashboard.menu[5]") }}
            </div>
            <div
              class="cabinet__menu-item _ml-8"
              :class="{
                'cabinet__menu-item_active': $route.name === 'Referal',
              }"
              @click="choiceMenuItem({ name: 'Referal' })"
            >
              {{ $t("cabinet.dashboard.menu[6]") }}
            </div>
          </div>
          <router-view />
        </div>
      </section>
    </main>

    <AppFooter />
  </section>
</template>

<script>
import AppHeader from "@/layouts/components/AppHeader";
import AppFooter from "@/layouts/components/AppFooter";
import { mapActions } from "vuex";
export default {
  name: "CabinetLayout",
  components: {
    AppHeader,
    AppFooter,
  },
  data: () => ({
    menuItem: 0,
  }),
  computed: {},
  methods: {
    ...mapActions(["fetchSession"]),
    choiceMenuItem(to) {
      this.$router.push(to).catch(() => {});
    },
  },
  mounted() {
    this.fetchSession();
  },
};
</script>

<style lang="scss" scoped>
.cabinet {
  &__menu {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    overflow-x: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
      width: 0 !important;
    }

    &-item {
      white-space: nowrap;
      cursor: pointer;
      padding-bottom: 24px;
      font-family: "Noto-Sans", sans-serif;
      font-style: normal;
      font-weight: 700;
      font-size: 20px;
      line-height: 24px;
      color: #707372;
      border-bottom: 2px solid transparent;
      transition: 0.3s;

      @media screen and (max-width: 743px) {
        font-size: 16px;
      }

      &:hover {
        color: #629727;
      }

      &_active {
        color: #629727;
        border-color: #629727;
      }
    }
  }

  &-layout {
    min-height: 100vh;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: min-content 1fr min-content;
  }
}
</style>
